import { Series } from '@/modules/core/legacy/charts/am5/base/models/Series';
import { Axis } from '@/modules/core/legacy/charts/am5/base/models/Axis';
import { BulletConfig } from '@/modules/core/legacy/charts/am5/base/models/BulletConfig';

/**
 * @class XYSeries
 * @extends Series
 */
export class XYSeries extends Series {
  /**
   * Set true if series category is date
   * @var {Boolean}
   */
  isCategoryDate;

  /**
   * Set true if series is stacked
   * @var {Boolean}
   */
  stacked;

  /**
   * Assign series specific axis
   * @var {Axis}
   */
  axis;

  /**
   * Index of the axis among all value axis
   * Index starts from zero
   * @var {Number}
   */
  axisIndex;

  /**
   * Index of the axis among category axis (In-case of date axis and comparison two category axis will be there)
   * Index starts from zero
   * @var {Number}
   */
  categoryAxisIndex;

  /**
   * Set true if to show labels for each data points
   * @var {Boolean}
   */
  showMetricLabels;

  /**
   * Give specific color to series
   * @var {String}
   */
  color;

  /**
   * Settings related to bullets
   * @var {BulletConfig}
   */
  bullet;

  /**
   * Array of colors to be assigned to the individual data points in the series. Assignment is done by rotation.
   * @var {Array}
   */
  colorSet;

  /**
   * Elements relative width. Value is treated as a percent.
   *
   * @var {Number}
   */
  columnWidth;

  /**
   * The value will range from 0 to 1
   * This is set to manage transparent in line stroke
   * @var {Number}
   */
  strokeOpacity;

  /**
   * Stroke width for line and bar charts
   * @var {Number}
   */
  strokeWidth;

  /**
   * Horizontal tension setting of the line (0-1).
   * Can be used to create smoothed lines.
   * @var {Number}
   */
  tension;

  /**
   * Item's open numeric value
   * @var {Number}
   */
  openValue;

  /**
   * Setting to false will make series overlap with other series
   * @var {Boolean}
   */
  isClustered;

  /**
   * Control opacity of element itself
   * @var {String}
   */
  opacity;

  /**
   * Column radius for top left.
   * @var {number}
   */
  columnCornerRadiusTopLeft;

  /**
   * Column radius for top right.
   * @var {number}
   */
  columnCornerRadiusTopRight;

  /**
   * Column radius for bottom left.
   * @var {number}
   */
  columnCornerRadiusBottomLeft;

  /**
   * Column radius for bottom right.
   * @var {number}
   */
  columnCornerRadiusBottomRight;

  /**
   * Give label to series
   * @var {String}
   */
  valueLabel;

  /**
   * Item value label's dx
   * @var {Number}
   */
  valueDx;

  /**
   * Item value label's color
   * @var {String}
   */
  labelFill;

  /**
   * Stroke Color for the column.
   * @var {String}
   */
  strokeColor;

  /**
   * Whether the series corresponds to a ranking metric or not
   * @var {Boolean}
   */
  isRankingMetric;

  constructor(model = {}) {
    super(model);
    this.date = model.date;
    this.stacked = model.stacked;
    this.axis = model.axis ? new Axis(model.axis) : null;
    this.isCategoryDate = model.isCategoryDate;
    this.showMetricLabels = model.showMetricLabels;
    this.color = model.color;
    this.bullet = new BulletConfig(model.bullet);
    this.colorSet = model.colorSet;
    this.opacity = model.opacity;
    this.columnWidth = model.columnWidth;
    this.strokeOpacity = model.strokeOpacity;
    this.strokeWidth = model.strokeWidth;
    this.tension = model.tension;
    this.openValue = model.openValue;
    this.isClustered = model.isClustered;
    this.axisIndex = model.axisIndex;
    this.categoryAxisIndex = model.categoryAxisIndex;
    this.columnCornerRadiusTopLeft = model.columnCornerRadiusTopLeft;
    this.columnCornerRadiusTopRight = model.columnCornerRadiusTopRight;
    this.columnCornerRadiusBottomLeft = model.columnCornerRadiusBottomLeft;
    this.columnCornerRadiusBottomRight = model.columnCornerRadiusBottomRight;
    this.patternSet = model.patternSet;
    this.valueLabel = model.valueLabel;
    this.valueDx = model.valueDx;
    this.labelFill = model.labelFill;
    this.strokeColor = model.strokeColor;
    this.noRisers = model.noRisers;
    this.isRankingMetric = model.isRankingMetric;
  }
}
